import { getEncodedUrl } from "@catchoftheday/utilities";
import { ONEPASS_OAUTH_REDIRECT, ONEPASS_SUBSCRIBE_URL } from "../consts";

export const generateOnePassLinkingUrl = (
  url: string,
  queryParams?: { [key: string]: string }
) =>
  `${ONEPASS_OAUTH_REDIRECT}?n=1&_destination=${encodeURIComponent(
    getEncodedUrl(url, {
      showmessage: "l",
      ...queryParams,
    })
  )}`;

export const generateOnePassUpsellUrl = (url: string) =>
  `${ONEPASS_SUBSCRIBE_URL}?_destination=${getEncodedUrl(url, {
    showmessage: "u",
  })}`;
